module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-ui-notification__position"><div class="ggs-ui-notification__button" ng-class=":: typeClass" ng-click=":: handler()"><div class="ggs-ui-notification__message" ng-bind=":: message"></div></div></div>';
return __p
}